import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ActionMenu = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const openMenu = () => {
    const rect = btnRef.current?.getBoundingClientRect();
    if (rect) {
      setPos({ top: rect.bottom + 4, right: window.innerWidth - rect.right });
      setOpen(true);
    }
  };

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const onPointerDown = (e) => {
      if (menuRef.current?.contains(e.target) || btnRef.current?.contains(e.target)) {
        return;
      }
      setOpen(false);
    };
    const onDismiss = () => setOpen(false);

    document.addEventListener('mousedown', onPointerDown);
    window.addEventListener('scroll', onDismiss, true);
    window.addEventListener('resize', onDismiss);

    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      window.removeEventListener('scroll', onDismiss, true);
      window.removeEventListener('resize', onDismiss);
    };
  }, [open]);

  return (
    <>
      <S.Trigger
        ref={btnRef}
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Actions"
        onClick={() => (open ? setOpen(false) : openMenu())}
      >
        <S.Dots aria-hidden="true">
          <span />
          <span />
          <span />
        </S.Dots>
      </S.Trigger>

      {open && pos && (
        <S.Menu
          ref={menuRef}
          role="menu"
          style={{ top: pos.top, right: pos.right }}
          onClick={() => setOpen(false)}
        >
          {children}
        </S.Menu>
      )}
    </>
  );
};

ActionMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ActionMenu;
